import "./PatientsDataHeader.scss";
import { Select, Segmented, Button, Checkbox } from "antd";
import CanDoAction from "../../../../../../common/services/Permissions/Can";
import { CreatePatient } from "../../../../../../modals";
import { useDispatch } from "react-redux";
import {
  getPatients,
  postPatient,
} from "../../../../../../features/patients/patientsActions";
import { constants } from "../../../../../../config/constants";

export default function PatientsDataHeader({
  token,
  isMobile,
  user,
  isAuthenticated,
  is_search_limit_reached,
  onsegmentChange,
  onCheckboxChange,
  searchParams,
  is_create_patient_opened,
  set_is_create_patient_opened,
  openNotificationWithIcon,
}) {
  const dispatch = useDispatch();

  const addPatient = (params, callBack) => {
    dispatch(postPatient(params))?.then((res) => {
      if (res?.type === "post_patient/fulfilled") {
        set_is_create_patient_opened(false);
        openNotificationWithIcon(
          "success",
          "Success",
          res?.payload?.message ||
            "Patient record created successfully. It is currently inactive and will be reviewed by an administrator."
        );
        if (typeof callBack === "function") {
          callBack();
        }
        dispatch(
          getPatients({
            search: searchParams?.get("search"),
            page: searchParams?.get("page") || 1,
            per_page: searchParams?.get("per_page") || 10,
            category: searchParams?.get("category") || "",
            own_only: searchParams?.get("own_only") || "",
            is_active: true,
          })
        );
      }
    });
  };

  return (
    <div className="patientData-contHeader">
      <div className="patientData-contHeader__filters">
        {isMobile ? (
          <Select
            disabled={is_search_limit_reached}
            style={{ width: "100%" }}
            options={constants?.patientsCategories}
            onChange={onsegmentChange}
            value={searchParams?.get("category") || ""}
          />
        ) : (
          <Segmented
            disabled={is_search_limit_reached}
            options={constants?.patientsCategories}
            onChange={onsegmentChange}
            value={searchParams?.get("category") || ""}
          />
        )}
        <CanDoAction isOrganization={isAuthenticated && user?.is_organization}>
          <Checkbox
            checked={searchParams?.get("own_only") === "true"}
            onChange={onCheckboxChange}>
            My Patients
          </Checkbox>
        </CanDoAction>
      </div>
      <CanDoAction isOrganization={isAuthenticated && user?.is_organization}>
        <Button
          type="primary"
          onClick={() => {
            set_is_create_patient_opened(true);
          }}
          size="middle">
          Create New
        </Button>
      </CanDoAction>

      <CreatePatient
        token={token}
        title={"Create New Patient"}
        isOpened={is_create_patient_opened}
        onCancel={() => {
          set_is_create_patient_opened(false);
        }}
        onOk={(params, callBack) => {
          addPatient(params, callBack);
        }}
      />
    </div>
  );
}
